import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

export interface GameStartResponse {
  session_id: string;
  game_type: string;
  difficulty: string;
  status: string;
  reaction: string;
  scenario: string;
  score: number;
  suggestions: string[];
}

export interface GameActionResponse {
  status: string;
  reaction: string;
  feedback: string;
  next_prompt: string;
  score_adjustment: number;
  suggestions: string[];
  response_quality: string;
}

export const startGame = async (gameType: string, difficulty: string): Promise<GameStartResponse> => {
  const token = localStorage.getItem('token');
  const url = `${API_URL}/game/start`;
  
  try {
    const response = await axios.post(url, 
      {
        game_type: gameType,
        difficulty: difficulty,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error starting game:', error);
    throw error;
  }
};

export const performGameAction = async (sessionId: string, action: string): Promise<GameActionResponse> => {
  const token = localStorage.getItem('token');
  const url = `${API_URL}/game/action`;
  
  try {
    const response = await axios.post(url,
      {
        session_id: sessionId,
        action: action,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error performing game action:', error);
    throw error;
  }
};

export const resumeGame = async (sessionId: string) => {
  const token = localStorage.getItem('token');
  const url = `${API_URL}/game/resume`;
  
  try {
    const response = await axios.post(url,
      {
        session_id: sessionId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error resuming game:', error);
    throw error;
  }
}; 